const GalerieCloud = function(ref){
    var cloud = document.getElementById('galerie-cloud');
    if(cloud) cloud.remove();
    cloud = document.body.createElementInside('div').addClass('galerie-cloud').addAttr('id', 'galerie-cloud');
    cloud.addEventListener('click', function(e){ this.remove();});

    this.image = function(img, prev, nex){
        var nn = nex;
        var pp = prev;
        var image = cloud.createElementInside('div').addClass('galerie-img');
        var loader = cloud.createElementInside('div').addClass('loader');
        var dim = cloud.offset();
        let d = (dim.width > dim.height) ? dim.height : dim.width;
        image.setStyle('width', d + 'px').setStyle('height', d + 'px');
        var pict = new Image();
        //pict.src = img.getAttr('href');
        pict.src = img.dataset.file;
        pict.addEventListener('load', function(e){if(this.complete) loader.remove(); this.addClass('show')});
        pict.setStyle('max-width', (d-60) + 'px').setStyle('max-height', (d-60) + 'px');
        image.append(pict);
        var previous = cloud.createElementInside('span').addClass('galerie-previous');
        var next = cloud.createElementInside('span').addClass('galerie-next');
        var close = image.createElementInside('span').addClass('galerie-close');
        previous.addEventListener('click', function(e){
            e.preventDefault();
            e.stopPropagation();
            pp.dispatchEvent(new Event('click'));
            return false;
        });
        next.addEventListener('click', function(e){
            e.preventDefault();
            e.stopPropagation();
            nn.dispatchEvent(new Event('click'));
            return false;
        });
    }
}

Element.prototype.galerie = function($options = []){

    const imgs = this.querySelectorAll('.galerie-thumb');

    this.modalImg = function(e){
        e.preventDefault();
        e.stopPropagation();
        let cloud = new GalerieCloud(this);
        let rand = this.dataset['rand'];
        let previous = (rand > 0) ? imgs[rand - 1] : imgs[imgs.length - 1];
        let next = (rand >= imgs.length - 1) ? imgs[0] : imgs[parseInt(rand) + 1];
        cloud.image(this, previous, next);
        return false;
    }

    for(let i = 0; i < imgs.length; i++){
        //imgs[i].dataset.rand = i;
        imgs[i].setAttribute('data-rand', i);
        imgs[i].addEventListener('click', this.modalImg);
    }

}


